import React from 'react';
import {Switch, Route} from 'react-router-dom';
import usePermission from '@/hooks/usePermission';

import ChangePassword from '@/views/ChangePassword';

import NewBusiness from '@/b2b/pages/NewBusiness';
import ServiceRecord from '@/b2b/pages/ServiceRecord';
import Clients from '@/b2b/pages/Clients';
import Report from '@/b2b/pages/Report';
import MyProfile from '@/b2b/pages/MyProfile';
import Mdrt from '@/b2b/pages/Mdrt';
import Commissions from '@/b2b/pages/Commissions';
// import OnlineApplicationForm from '@/b2b/OnlineApplication/Form';
import Error404 from '@/Error404';

const Routes = ({match}) => {
  const {canAccessB2BCommission} = usePermission();
  return (
    <Switch>
      <Route path={match.url} exact component={NewBusiness} />
      <Route path={`${match.url}/clients`} component={Clients} />
      <Route path={`${match.url}/service_records`} component={ServiceRecord} />
      <Route path={`${match.url}/change_password`} component={ChangePassword} />
      <Route path={`${match.url}/reports`} component={Report} />
      <Route path={`${match.url}/my_profile`} component={MyProfile} />
      <Route path={`${match.url}/mdrt`} component={Mdrt} />
      {canAccessB2BCommission() && (
        <Route path={`${match.url}/commissions`} component={Commissions} />
      )}
      {/* <Route path={match.url + '/oaa/new'} component={OnlineApplicationForm} /> */}
      <Route component={Error404} />
    </Switch>
  );
};

export default Routes;
